import "@/App.css";
import "@/i18n";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { ChatWidget } from "@/components/ChatWidget";
import Home from "@/pages/Home"; // eager — Home is the most-visited landing page

// Code-split everything else so the initial bundle is small
const Tours = lazy(() => import("@/pages/Tours"));
const TourDetail = lazy(() => import("@/pages/TourDetail"));
const TravelGuide = lazy(() => import("@/pages/TravelGuide"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const About = lazy(() => import("@/pages/About"));
const BusinessCard = lazy(() => import("@/pages/BusinessCard"));
const Assistant = lazy(() => import("@/pages/Assistant"));
const AdminWidgets = lazy(() => import("@/pages/AdminWidgets"));

const PageFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#EDF6F9]">
    <div className="w-10 h-10 rounded-full border-4 border-[#006D77]/20 border-t-[#006D77] animate-spin" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#EDF6F9]">
        <BrowserRouter>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            {/* Standalone pages without navbar/footer */}
            <Route path="/card" element={<BusinessCard />} />
            <Route path="/assistant" element={<Assistant />} />
            <Route path="/admin/widgets" element={<AdminWidgets />} />

            {/* Main site with navbar/footer */}
            <Route path="*" element={
              <>
                <Navbar />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/tours" element={<Tours />} />
                    <Route path="/tours/:slug" element={<TourDetail />} />
                    <Route path="/guide" element={<TravelGuide />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/about" element={<About />} />
                  </Routes>
                </main>
                <Footer />
                <ScrollToTop />
              </>
            } />
          </Routes>
        </Suspense>
          <ChatWidget />
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
